import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {toastr} from 'react-redux-toastr';
import {Link} from 'react-router-dom';
import * as userActions from '../../actions/userActions';
import * as companyActions from '../../actions/companyActions';
import * as modalActions from '../../actions/common/modalActions';
import UsersList from './UsersList';
import CustomModal from '../../components/CustomModal.jsx';
import MediaQuery from 'react-responsive';
import UsersListDivs from "./UsersListDivs";
import * as roles from '../../services/access/roles';
import BaseList from "../common/list/BaseList";
import SearchBarContainer from '../common/searchbar/SearchBarContainer';
import CustomPagination from '../../components/common/CustomPagination';
import * as sortableListActions from "../../actions/common/sortableListActions";
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';
import WithResolvedPromises from "../common/WithResolvedPromises";
import PlaceholderTable from "../common/PlaceholderTable";
import PlaceholderError from "../common/PlaceholderError";

class UsersListContainer extends BaseList {

    constructor(props) {
        super(props);
        this.changeCompany      = this.changeCompany.bind(this);
        this.changeIsWebmaster  = this.changeIsWebmaster.bind(this);
        this.onDelete           = this.onDelete.bind(this);

        this.listId = 'users';
        this.state  = {
            page: 1,
            searchText: '',
            actions: this.getRequiredActions()
        };
    }

    getRequiredActions() {
        return [
            this.props.actions.loadUsers(1),
            this.props.actions.loadCompanies('*')
        ]
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.sortParamWasChanged(nextProps)) {
            nextState.page = 1;
        }
    }

    componentWillUnmount() {
        this.props.actions.resetList(this.listId);
    }

    changeCompany(companyId, userId) {
        if(companyId) {
            this.props.actions.addMembers(companyId, [userId]);
        }
        else {
            this.props.actions.detachCompany([userId]);
        }

    }

    changeIsWebmaster(userId, isWebmaster) {
        isWebmaster
            ? this.props.actions.addUserRoles(userId, [roles.FBG_WEBMASTER])
            : this.props.actions.removeUserRoles(userId, [roles.FBG_WEBMASTER]);
    }

    onDelete(id) {
        if(id == this.props.user.id) {
            toastr.error(this.props.intl.formatMessage(messages.usersDeleteOwnError));
            return;
        }

        this.deleteUserId = id;
        this.props.actions.showModal();
    }

    deleteUser() {
        if(!this.deleteUserId) {
            toastr.error(this.props.intl.formatMessage(messages.usersDeleteUserError));
            this.props.actions.hideModal();
            return;
        }

        this.props.actions.deleteUser(this.deleteUserId).then(() => {
            this.deleteUserId = null;
            this.props.actions.hideModal();
            toastr.success(this.props.intl.formatMessage(messages.usersUserDeleted));
        });
    }

    onPageChange(addActions, pageNum) {
        let page = pageNum.selected + 1;
        let promise = this.props.actions.loadUsers(page, this.getSortParams(this.props));
        addActions([promise]);
        this.setState({page: pageNum.selected + 1});
    }

    render() {
        let users       = this.props.users.data || [];
        let companies   = this.props.companies.data;
        let user        = this.props.user;

        return (
            <WithResolvedPromises promises={this.state.actions} preloaderComponent={PlaceholderTable}  errorComponent={PlaceholderError}>
                {
                    addActions => {
                        return(
                            <div>
                                <div className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-block">
                                                <div className="row">
                                                    <div className="col-6"><h1>{this.props.intl.formatMessage(messages.userListTitle)}</h1></div>
                                                    <div className="col-sm-6 pt-2">
                                                        <Link to="/brugere/skab" className="btn btn-primary waves-effect pull-right">
                                                            {this.props.intl.formatMessage(messages.userListCreate)}</Link>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-6 offset-6">
                                                        <SearchBarContainer listId={this.listId} loadDataAction={userActions.loadUsers} />
                                                    </div>
                                                </div>
                                                <MediaQuery query='(max-device-width: 768px)'>
                                                    <UsersListDivs
                                                        user={user}
                                                        users={users}
                                                        companies={companies}
                                                        changeCompany={this.changeCompany}
                                                        changeIsWebmaster={this.changeIsWebmaster}
                                                        onDelete={this.onDelete}
                                                    />
                                                </MediaQuery>
                                                <MediaQuery query='(min-device-width: 769px)'>
                                                    <UsersList
                                                        listId={this.listId}
                                                        user={user}
                                                        users={users}
                                                        companies={companies}
                                                        changeCompany={this.changeCompany}
                                                        changeIsWebmaster={this.changeIsWebmaster}
                                                        onDelete={this.onDelete}
                                                    />
                                                </MediaQuery>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <CustomPagination
                                        total={this.props.users.total}
                                        page={this.state.page}
                                        onPageChange={this.onPageChange.bind(this, addActions)}
                                    />
                                </div>
                                <CustomModal
                                    modalTitle={this.props.intl.formatMessage(messages.usersDeleteModalTitle)}
                                    modalContent={<p>{this.props.intl.formatMessage(messages.usersDeleteQuestion)}</p>}
                                    confirmText={this.props.intl.formatMessage(messages.deleteModalConfirmButton)}
                                    closeText={this.props.intl.formatMessage(messages.deleteModalCancelButton)}
                                    handleConfirm={() => {this.deleteUser()}}
                                />
                            </div>
                        );
                    }
                }
            </WithResolvedPromises>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        user: state.user,
        users: state.users,
        companies: state.companies,
        sortableList: state.sortableList,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                userActions,
                companyActions,
                modalActions,
                sortableListActions,
            ), dispatch
        )
    }

}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(UsersListContainer));


// WEBPACK FOOTER //
// ./web/src/components/users/UsersListContainer.jsx